import { atom } from 'recoil';

type DateRange = {
  startDate: string | null;
  endDate: string | null;
};

export const usedCouponUsersDateRangeState = atom<DateRange>({
  key: 'usedCouponUsersDateRangeState',
  default: { startDate: null, endDate: null }
});